// OE 20-06-2018
// All OK except header and footer in MWC
//
import * as _ from 'underscore';
import * as $ from 'jquery';

var html2canvas = require('html2canvas');
import { jsPDF } from 'jspdf';
import { config } from '../../../pdc-platform/src/ts/config';
import {
    IActionType,
    addFonts,
    isRelativeURL,
    img2Canvas,
    svg2Canvas,
    prepareTransparency,
    getAlignStyle,
    tableToPDF,
    isImgExist,
    addExtraInfo
} from './printContentUtils';
import {
    IMakeHTMLTableForPrinting,
    IHTMLTablePropertiesForPrinting,
    IPageOrientation
} from '../../../pdc-platform/src/ts/Interfaces';
// Default export is a4 paper, portrait, using millimeters for units

const TestMode = false;
export const DEFAULT_PRINT_LIMIT = 1000; //Do not delete
const loadingIndicatorHeigth = 150;

export interface IPDFOptions {
    outputFormat?: string;
    papersize?: string;
    layout?: IPageOrientation;
    showClock?: boolean;
    showTitle?: boolean;
    showPages?: boolean;
    makeHTMLTableForPrinting?: IMakeHTMLTableForPrinting;
    onReady?: (pdf: Blob | string | void) => void;
}

const TO_PIXELS = 3.7795275591; //2.834667; // mm to pixels coeff (72dpi)
const TO_PDF_DPI = 96.0 / 72.0; // coeff to convert to Chrome PDF resolution (96dpi)
const standardSizes = {
    A0: { width: 841, height: 1189 },
    A1: { width: 594, height: 841 },
    A2: { width: 420, height: 594 },
    A3: { width: 297, height: 420 },
    A4: { width: 210, height: 297 },
    A5: { width: 148, height: 210 },
    Legal: { width: 216, height: 356 },
    Letter: { width: 216, height: 279 },
    Tabloid: { width: 279, height: 432 }
};

const MARGIN = 20;

export default function printContent(
    glob,
    name: string,
    container: HTMLElement,
    pageHeader?: string,
    pageFooter?: string,
    coverPage?: string,
    templateParams?: any,
    actionType?: IActionType,
    pdfOptions?: IPDFOptions,

    widgetType?: string
) {
    let popup;
    let popupDocument;
    var headerTextAligh;
    var footerTextAligh;
    if (actionType == IActionType.exportToPdf || actionType == IActionType.copyToClipboard) {
        const popupCenter = ({ url, title, w, h }) => {
            const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
            const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

            const width = window.innerWidth
                ? window.innerWidth
                : document.documentElement.clientWidth
                ? document.documentElement.clientWidth
                : screen.width;
            const height = window.innerHeight
                ? window.innerHeight
                : document.documentElement.clientHeight
                ? document.documentElement.clientHeight
                : screen.height;

            const systemZoom = width / window.screen.availWidth;
            const left = (width - w) / 2 / systemZoom + dualScreenLeft;
            const top = (height - h) / 2 / systemZoom + dualScreenTop;

            popup = window.open(
                url,
                '_blank',
                `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, fullscreen=no
              width=${w / systemZoom},
              height=${h / systemZoom},
              top=${top},
              left=${left}
              `
            );
        };
        popupCenter({ url: '#1', title: 'PDF', w: 80, h: 80 });

        const setWindowTitle = () => {
            if (popup.document) {
                popupDocument = popup.document;
                popup.document.write('<title>' + 'PDF' + '</title>');
            } else {
                setTimeout(setWindowTitle, 10);
            }
        };

        setWindowTitle();
        popup.focus();
    } else {
        popup = window.open('', 'platformPrint', 'width=800,height=600');

        if (popup.document == null) {
            return;
        }

        popupDocument = popup.document;
    }

    const isIE = /(MSIE|Trident\/|Edge\/)/i.test(navigator.userAgent);
    const isFF = /(Firefox)/i.test(navigator.userAgent);
    // const isChrome = /(Chrome)/i.test(navigator.userAgent);
    // const isSafari = /(Safari)/i.test(navigator.userAgent);
    const layout = pdfOptions.layout?.length > 0 ? pdfOptions.layout : 'auto';
    const papersize = pdfOptions.papersize?.length > 0 ? pdfOptions.papersize : 'auto';
    // For WebKit browsers we need to preserve Zoom factor to
    // make Pivot grid drawing consistence
    const ps = standardSizes[papersize];

    let printSize = '';

    if (papersize == 'A3' || papersize == 'A4' || papersize == 'A5' || papersize == 'Legal' || papersize == 'Latter') {
        printSize = papersize + ' ' + layout;
    } else {
        if (layout === 'portrait') {
            printSize = ps.width + 'mm ' + ps.height + 'mm';
        } else {
            printSize = ps.height + 'mm ' + ps.width + 'mm';
        }
    }
    //style="size: ' + printSize + '"
    const bodyElem =
        '<body  ' +
        (actionType == IActionType.exportToPdf || actionType == IActionType.copyToClipboard
            ? ' style="overflow: hidden"'
            : '') +
        '>';
    // if (isChrome || isSafari) {
    //     var zoom = Math.round((window.outerWidth / window.innerWidth) * 100) / 100;
    //     if (zoom !== 1) {
    //         bodyElem = '<body style="zoom:' + zoom + ';">';
    //     }
    // }
    // else if (isSafari) {
    //     console.log('Safari');
    //     var zoom = Math.round(((document.documentElement.clientWidth) / window.innerWidth) * 100) / 100;
    //     console.log('ZOOM:' + zoom);
    //     if (zoom !== 1) {
    //         bodyElem = '<body style="zoom:' + zoom + ';">'
    //     }
    // }

    popupDocument.write('<!DOCTYPE html><html><head></head>' + bodyElem + '</body></html>');

    const commonStyle = 'top: 10px; height:40px; width:40px; left: 35px; position: absolute; font-size: smaller;';

    if (actionType == IActionType.exportToPdf || actionType == IActionType.copyToClipboard) {
        const style =
            commonStyle +
            '\
        border: 16px solid #f3f3f3;\
         border-top: 16px solid #3498db;\
         border-radius: 50%;\
         width: 40px;\
         height: 40px;\
         top: 30px;\
         animation: spin 2s linear infinite;';
        $(popupDocument.body).append('<div id="loadingIndicator" style="' + style + '"></div>');

        $(document).ready(function () {
            let parentTable = $(popupDocument.body).find('.parentTable');

            if (parentTable && parentTable.length > 0) {
                parentTable[0].style.top = '150px';
                parentTable[0].style.position = 'absolute';
            }

            $(popupDocument.body).append('<div style="top: 10px; ' + commonStyle + '">Loading...</div>');
        });
    }

    _.each(document.querySelectorAll('link[rel="stylesheet"]'), (link: HTMLLinkElement) => {
        const copy = popupDocument.createElement('link');

        copy.rel = link.rel;
        copy.href = link.href;
        popupDocument.head.appendChild(copy);
    });

    _.each(document.getElementsByTagName('style'), (elem) => {
        const copy = document.createElement('style');
        copy.innerHTML = elem.innerHTML;
        var _h = copy.outerHTML;
        $(popupDocument.head).append(_h);
    });

    const styleR = popupDocument.createElement('style');

    styleR.innerHTML = ' .replaceP{ margin-bottom: 1rem; }';
    $(popupDocument.head).append(styleR);

    const pageStyle = document.createElement('style');

    $(popupDocument.head).append(pageStyle);

    const containers: HTMLElement[] = [];

    let parent: HTMLElement = container;

    while (parent != null) {
        if (/\b(widget|workspace-view-container)\b/.test(parent.className)) {
            containers.unshift(parent);
        }

        parent = parent.parentElement;
    }

    const base = popupDocument.createElement('div');

    const container_ = _.reduce<HTMLElement[], HTMLElement>(
        containers,
        (res, element: HTMLElement) => {
            const next = popupDocument.createElement('div');
            if (element.id && element.id.length > 0) {
                next.id = element.id;
            }
            res.appendChild(next);

            return next;
        },
        base
    );

    popupDocument.body.className = 'pdc-print-pdf pdc-platform';

    const dx_hack = popupDocument.createElement('div');

    $(dx_hack).addClass(
        'dx-viewport dx-device-desktop dx-device-generic dx-theme-generic dx-theme-generic-typography dx-color-scheme-light'
    );

    popupDocument.body.appendChild(dx_hack);
    $(container_).children().remove();

    const original = $(container); //.children();
    const cloned = original.clone();
    //cloned.width(original.width());

    /*let owcontainers = $(original).closest('.' + widgetType);
    if (owcontainers && owcontainers.length > 0) {
        cloned.height(original.height());
    }*/

    // OE - 29-May-2005. Changing height of the parent container for HTML widget
    // causes https://support.pdc.com/portal/#issue/92689
    if (widgetType === 'pdc-widget-layout') {
        // || widgetType === 'pdc-widget-html') {
        _.each(containers, (container) => {
            $(container).parent().css('height', '100%');
            $(cloned).css('overflow', 'hidden');
        });
    }

    cloned.css('position', 'relative');

    _.map(_.zip($('canvas', cloned).toArray(), $('canvas', original).toArray()), ([cloned, original]) => {
        const context = (cloned as any).getContext('2d');

        if ((original as any).width > 0 && (original as any).height > 0) {
            // Guard against canvases with zero dimension - this can happen in Gantt widget and will otherwise cause exception and a blank page
            context.drawImage(original, 0, 0);
        }
    });

    //symplify structure for pdf generaton
    _.each($('.dx-button-content', cloned).toArray(), (button: any) => {
        const icon = button.querySelector('.dx-icon');

        if (icon) {
            $(button).removeClass('dx-button-content');
        }
    });

    _.each($('canvas', cloned).toArray(), (canvas: any) => {
        try {
            //$(canvas).attr('crossOrigin', 'anonymous');
            const ctx = canvas.getContext('2d');

            prepareTransparency(canvas, ctx);

            const imageUrl = canvas.toDataURL('image/jpeg');
            const img = popupDocument.createElement('img');

            img.height = canvas.height;
            img.width = canvas.width;
            img.src = imageUrl;
            $(canvas).replaceWith(img);
        } catch (e) {
            console.log(e.message);
        }
    });

    _.each($('.dx-scrollable-container', cloned).toArray(), (el) => {
        //92349: Print to PDF does not include all rows. Solution is to set thes css for table parent
        $(el).css('height', 'auto');
        $(el).css('overflow', 'visible');
    });
    _.each($('.dx-column-indicators', cloned).toArray(), (el) => {
        $(el).replaceWith('');
    });
    _.each($('.dx-sort-indicator', cloned).toArray(), (el) => {
        $(el).removeClass('dx-sort-indicator');
    });

    _.each($('.dx-datagrid-header-panel', cloned).toArray(), (el) => {
        $(el).replaceWith('');
    });

    _.each($('.d-print-none', cloned).toArray(), (el) => {
        $(el).css('display', 'none');
    });

    _.each($('.dx-scrollable-both', cloned).toArray(), (dx) => {
        //81715: "Hosting" page. PDF (or Print Preview) always shows a scrollbar for Grid if a page-break falls in the middle = BUG
        $(dx).removeClass('dx-scrollable-both');
    });

    _.each($('input', cloned).toArray(), (input: any) => {
        const value = input.value;

        $(input).attr('value', value);

        $(input).css('padding', '1px');
    });

    _.each($('p', cloned).toArray(), (p: any) => {
        var _html = p.innerHTML;
        let style = p.style;
        let pstyle = style.cssText;
        $(p).replaceWith('<div class="replaceP" style="' + pstyle + '" >' + _html + '</div>');
    });

    // Remove fixed overlay for DataEdit, which gives additional lines accros rows
    _.each($('.dx-datagrid', cloned), (datagridElement) => {
        $(datagridElement).find('.dx-datagrid-rowsview').find('.dx-datagrid-content-fixed').remove();
    });

    // Convert DxData grid for printing, repeating headers on each page
    _.each($('.dx-datagrid', cloned).toArray(), (table) => {
        const gridtable = $(table).find('.dx-datagrid-rowsview').find('.dx-datagrid-table')[0] as HTMLTableElement;
        var headerTable = $(table).find('.dx-datagrid-headers');
        var className = headerTable.attr('class');
        const headerRows = headerTable.find('tr').filter(function () {
            return $(this).closest('.dx-datagrid-content-fixed').length === 0;
        });
        const header = gridtable.createTHead();
        $(header).addClass(className);
        $(header).append(_.clone(headerRows));
        $(gridtable).append(header);

        $(table).css('width', 'fit-content');
        const freespacerow = $(table).find('.dx-freespace-row');
        if (freespacerow && freespacerow.length > 0) {
            freespacerow.remove();
        }
    });

    // Remove command column for DataEdit
    _.each($('.dx-datagrid-table', cloned).toArray(), (table) => {
        _.each($('tr', table).toArray(), (tr) => {
            $(tr).find('td.dx-command-edit').remove();
        });
    });

    // Replace inline-block styles for cke-pdc-widget with inline
    _.each($('.cke-pdc-widget', cloned).toArray(), (widget) => {
        if ($(widget).css('display') === 'inline-block') {
            $(widget).css('display', 'inline');
        }
    });

    // Change CKEdit pageBreak from :after to :before
    // :after does not work in Chrome
    _.each(
        //$('div[style*="page-break-after:always"]', cloned).toArray(),
        $('div', cloned).toArray(),
        (d: any, index) => {
            if (d.style != null) {
                if (d.style.pageBreakAfter != null && d.style.pageBreakAfter !== '') {
                    var _html = d.innerHTML;
                    const elementId = 'page' + index;
                    if (isFF) {
                        $(d).replaceWith(
                            '<div style="break-after:always" class="pageBreak" id="' +
                                elementId +
                                '" >' +
                                _html +
                                '</div>'
                        );
                    } else if (!isIE) {
                        $(d).replaceWith(
                            '<div style="page-break-before:always" class="pageBreak" id="' +
                                elementId +
                                '" >' +
                                _html +
                                '</div>'
                        );
                    }
                }
            }
        }
    );

    _.each(cloned, (el) => {
        const _html = el.outerHTML;

        $(container_).append(_html);
    });

    const parentTable = popupDocument.createElement('div');

    $(parentTable).addClass('parentTable');

    const contentTable = popupDocument.createElement('table');

    $(parentTable).append(contentTable);
    $(contentTable).addClass('printContent');

    const tab = popupDocument.createElement('table');
    const extraInfoTable = popupDocument.createElement('div');
    var tr = popupDocument.createElement('tr');
    var td = popupDocument.createElement('td');
    // $(extraInfoTable).css('height', $(window).height() + 'px')
    $(td).append(extraInfoTable);
    $(tr).append(td);
    $(tab).append(tr);

    $(parentTable).append(tab);
    $(extraInfoTable).addClass('extraInfo');

    if (actionType == IActionType.exportToPdf || actionType == IActionType.copyToClipboard) {
        const paperSize = getPageDimensions(pdfOptions.papersize, pdfOptions.layout);

        // $(contentTable).css("minHeight", paperSize.height);
        $(contentTable).css('minWidth', paperSize.width);
    }

    if (actionType === IActionType.print) {
        const thead = popupDocument.createElement('thead');

        if (pdfOptions?.showTitle) {
            const caption = popupDocument.createElement('caption');

            $(caption).css('width', '100%');
            $(caption).css('captionSide', 'top');
            $(caption).css('text-align', 'center');
            $(caption).css('paddingBottom', '10px');
            $(caption).css('fontWeight', 'bold');
            $(caption).css('fontSize', '40px');
            $(caption).html(name);
            $(contentTable).append(caption);
        }
        if (pdfOptions?.showClock) {
            const now = new Date();
            const tftr1 = popupDocument.createElement('tr');
            const tftd1 = popupDocument.createElement('td');

            $(tftd1).css('float', 'right');
            $(tftd1).html(now.toDateString());
            $(tftr1).append(tftd1);
            $(thead).append(tftr1);
            $(contentTable).append(thead);
        }

        if (pageHeader != null) {
            let style = getAlignStyle(pageHeader);

            let textAlign = style && style['text-align'];
            let float = style && style['float'];
            const thtr = popupDocument.createElement('tr');
            const thtd = popupDocument.createElement('td');

            $(thtd).css('width', '100%');
            const mediaPrintStyle = popupDocument.createElement('style');
            $(thtd).addClass('tdheader');
            mediaPrintStyle.type = 'text/css';
            mediaPrintStyle.media = 'print';
            if (textAlign) {
                $(thtd).attr('style', 'text-align:' + textAlign + ' !important');
                mediaPrintStyle.innerHTML = '.tdheader {text-align:' + textAlign + ' !important;}';
            }
            if (float) {
                $(thtd).attr('style', 'float:' + float + ' !important');
                mediaPrintStyle.innerHTML = '.tdheader {float:' + float + ' !important;}';
            }
            popupDocument.head.appendChild(mediaPrintStyle);
            //$(td).css('left', MARGIN + 'px');
            $(thtd).html(pageHeader);
            $(thtr).append(thtd);
            $(thead).append(thtr);
            $(contentTable).append(thead);

            const imgs = $(thead)[0].getElementsByTagName('img');

            _.each(imgs, (img: any) => {
                let url = img.src;
                let absUrl = url;

                if (url) {
                    if (isRelativeURL(url)) {
                        absUrl = img.src.replace(/^\.\//, config.API_ENDPOINT + '/');
                    }

                    if (window.location.host === 'localhost') {
                        absUrl = img.src.replace(
                            window.location.origin + window.location.pathname,
                            config.API_ENDPOINT + '/'
                        );
                    }

                    $(img).attr('src', absUrl);

                    if (img.width) {
                        $(img).width(img.width);
                    }

                    if (img.height) {
                        $(img).height(img.height);
                    }
                }
            });
        }
    }

    const tbody = popupDocument.createElement('tbody');
    var tr = popupDocument.createElement('tr');
    var td = popupDocument.createElement('td');

    $(td).append($(base).children());
    $(td).css('left', MARGIN + 'px');
    $(td).css('top', 10 + 'px');
    //$(td).css('position', 'static');
    $(tr).append(td);
    $(tbody).append(tr);

    $(contentTable).append(tbody);

    if (actionType === IActionType.print) {
        if (pdfOptions?.showPages) {
            const pagestyle = popupDocument.createElement('style');

            pagestyle.type = 'text/css';
            pagestyle.innerHTML =
                //IL: 81715: "Hosting" page. PDF (or Print Preview) always shows a scrollbar for Grid if a page-break falls in the middle = BUG

                pagestyle.innerHTML =
                    '@page {' +
                    '@bottom-center { ' +
                    'content: "Page " counter(page) " of " counter(pages)}; font-size: 8px; ' +
                    'font-style: italic; margin: ' +
                    MARGIN +
                    'px;}';

            popupDocument.head.appendChild(pagestyle);
        }
        if (pageFooter != null) {
            var footerTmp = popupDocument.createElement('div');
            footerTmp.innerHTML = pageFooter;
            let style = getAlignStyle(pageFooter);
            let textAlign = style && style['text-align'];
            let float = style && style['float'];
            const tfoot = popupDocument.createElement('tfoot');
            const tftr = popupDocument.createElement('tr');
            const tftd = popupDocument.createElement('td');

            if (textAlign) {
                $(tftd).css('text-align', textAlign);
            }
            if (float) {
                $(tftd).css('float', float);
            }
            //$(tftd).append('<table width="100%"><tr><td colspan="4" style="height:'+footerHeigth*2+'px"><p>ÐÐ»ÑÐ´Ð²Ð° Ð¿Ð¾Ð·Ð¾ÑÐ½Ð°Ñ&nbsp;</p></td></tr></table>');
            $(tftd).html(pageFooter);
            $(tftd).css('visibility', 'hidden');
            $(tftr).append(tftd);
            $(tfoot).append(tftr);
            $(contentTable).append(tfoot);
            //https://estart.hr/en/news/19/HTML--CSS:-Create-header-and-footer-on-the-top-and-bottom-of-every-printed-page/
            const div = popupDocument.createElement('div');
            $(div).append(footerTmp);
            $(parentTable).append(div);
            $(footerTmp).css('text-align', textAlign);
            $(div).css('position', 'fixed');
            $(div).css('bottom', '0');
            $(div).css('width', '100%');
            const imgs = $(tfoot)[0].getElementsByTagName('img');

            _.each(imgs, (img: any) => {
                let url = img.src;
                let absUrl = url;

                if (url) {
                    if (isRelativeURL(url)) {
                        absUrl = absUrl.replace(/^\.\//, config.API_ENDPOINT + '/');
                    }

                    if (window.location.host === 'localhost') {
                        absUrl = absUrl.replace(
                            window.location.origin + window.location.pathname,
                            config.API_ENDPOINT + '/'
                        );
                    }

                    $(img).attr('src', absUrl);

                    if (img.width) {
                        $(img).width(img.width);
                    }

                    if (img.height) {
                        $(img).height(img.height);
                    }
                }
            });
        }
    }

    let coverPageDiv;

    if (coverPage != null) {
        coverPageDiv = popupDocument.createElement('div');

        let coverPageContent = coverPage;

        coverPageDiv.className = 'coverPage';

        if (templateParams != null) {
            const compiled = _.template(coverPage.replace('&lt;%', '<%').replace('%&gt;', '%>'), {
                interpolate: /<%(.+?)%>/g
            });

            try {
                coverPageContent = compiled(templateParams);
            } catch (e) {
                console.log(e.message);
                coverPageContent = '';
            }
        }

        $(coverPageDiv).html(coverPageContent);

        if (actionType === IActionType.print) {
            popupDocument.body.appendChild(coverPageDiv);
        }
    }

    popupDocument.body.appendChild(parentTable);

    const styleS = popupDocument.createElement('style');

    styleS.type = 'text/css';
    styleS.media = 'screen';

    styleS.innerHTML =
        '#' +
        $(popupDocument.body).children()[0].id +
        '{ -ms-overflow-y: auto; -ms-overflow-x: auto; height: ' +
        $(window).height() +
        'px }';

    const pdcWidgetWorkspace = popupDocument.getElementsByClassName('pdc-widget-workspace');

    if (pdcWidgetWorkspace.length > 0 && pdcWidgetWorkspace[0]) {
        $(pdcWidgetWorkspace[0]).css('position', 'relative');
    }

    const pdcWidgetMultiple = popupDocument.getElementsByClassName('pdc-widget-multiple');

    if (pdcWidgetMultiple.length > 0 && pdcWidgetMultiple[0]) {
        $(pdcWidgetMultiple[0]).css('position', 'relative');
    }

    /*var pdcWidgetHtml = popup_document.getElementsByClassName('pdc-widget-html');
    if (pdcWidgetHtml.length>0 && pdcWidgetHtml[0]){
        $(pdcWidgetHtml[0]).css('position', 'relative');
    }*/

    //always comes from ckeditor pagebreak plugin
    const styleP = popupDocument.createElement('style');

    styleP.type = 'text/css';
    styleP.media = 'print';

    if (isFF) {
        styleP.innerHTML =
            //IL: 81715: "Hosting" page. PDF (or Print Preview) always shows a scrollbar for Grid if a page-break falls in the middle = BUG
            ' .dx-datagrid-rowsview{ break-after: avoid; }' + //'div{ break-after: avoid;}' +
            '.replaceP{ break-after: auto; }' +
            ' .coverPage{ break-after: always !important; }' +
            ' tr{ break-inside: auto !important; } ';
    } else {
        styleP.innerHTML =
            ' .dx-datagrid-rowsview{ page-break-after: avoid }' + //'div{ page-break-after: avoid;}' +
            ' .replaceP{ page-break-after: auto }' +
            ' .coverPage{ page-break-after: always !important }' +
            ' tr{ page-break-inside: auto !important }';
    }

    styleP.innerHTML = styleP.innerHTML + ' .pdc-widget-cards-card {display: block} ';

    styleP.innerHTML =
        styleP.innerHTML +
        '*,\
        *::before,\
        *::after {\
        text-shadow: none !important;\
        box-shadow: none !important; }';

    const mediaPageSize = popupDocument.createElement('style');

    mediaPageSize.type = 'text/css';
    mediaPageSize.media = 'print';

    if (printSize?.length > 0) {
        mediaPageSize.innerHTML = '@page {size: ' + ' ' + printSize + '; margin: 15mm;}';
    } else {
        mediaPageSize.innerHTML = '@page {size: auto !important; margin: 15mm; }}';
    }

    popupDocument.head.appendChild(mediaPageSize);
    popupDocument.head.appendChild(styleP);
    popupDocument.head.appendChild(styleS);

    const cardsRoot = popupDocument.getElementsByClassName('pdc-widget-cards');

    if (cardsRoot.length > 0) {
        $(cardsRoot[0]).css('background', 'transparent');
    }

    const htmlRoot = popupDocument.getElementsByClassName('pdc-widget-html');

    if (htmlRoot.length > 0) {
        $(htmlRoot[0]).css('background', 'transparent');
    }

    popupDocument.close();

    let footerImg;
    let headerImg;
    let coverPageImg;

    const GIS2Canvas = (): JQuery.Promise<any>[] => {
        const paperSize = getPageDimensions(pdfOptions.papersize, pdfOptions.layout);
        const defs = [];
        const gis = popupDocument.getElementsByClassName('pdc-widget-gis');
        const origGis = _.clone(container.getElementsByClassName('pdc-widget-gis'));

        if (origGis && origGis.length > 0) {
            const gisImg = new Image();
            const pageWidth = paperSize.width - MARGIN * 2;

            let width = $(origGis).width();
            let height = $(origGis).height();

            if (width > pageWidth) {
                height = (pageWidth * height) / width;
                width = pageWidth;
            }

            gisImg.width = width;
            gisImg.height = height;
            defs.push(
                html2Canvas(origGis[0], gisImg, defs.length).done((index) => {
                    $(gis).replaceWith(gisImg);
                    defs[index].resolve();
                })
            );
        }
        return defs;
    };

    const Progressbar2Canvas = (): JQuery.Promise<any>[] => {
        const defs = [];

        const processbars = popupDocument.getElementsByClassName('processbar_container');
        _.each(processbars, (processbar) => {
            const Img = new Image();
            Img.width = $(processbar).width();
            $(processbar).width($(processbar).width() + 2);
            defs.push(
                html2Canvas(processbar, Img, defs.length, 'image/png', null).done((index) => {
                    $(processbar).replaceWith(Img);
                    defs[index].resolve();
                })
            );
        });

        return defs;
    };

    const imgToCanvas = (defs): JQuery.Promise<any>[] => {
        let imgs = _.clone(popupDocument.getElementsByTagName('img'));
        if (imgs && imgs.length > 0) {
            _.each(imgs, (image) => {
                let url = image.src;
                let absUrl = url;

                if (isDataURL(url)) {
                    return;
                }
                if (absUrl) {
                    if (isRelativeURL(absUrl)) {
                        absUrl = absUrl.replace(/^\.\//, config.API_ENDPOINT + '/');
                    }
                    if (window.location.host === 'localhost') {
                        absUrl = absUrl.replace(
                            window.location.origin + window.location.pathname,
                            config.API_ENDPOINT + '/'
                        );
                    }
                }
                image.src = absUrl;

                var tmpImg = popupDocument.createElement('img');

                tmpImg.crossOrigin = 'anonymous';
                tmpImg.src = absUrl;
                tmpImg.width = image.scrollWidth;
                tmpImg.height = image.scrollHeight;

                extraInfoTable.appendChild(tmpImg);
                defs.push(
                    img2Canvas(tmpImg, image, defs.length).done((index) => {
                        defs[index].resolve();
                    })
                );
                if (tmpImg) {
                    tmpImg.parentNode.removeChild(tmpImg);
                }
            });
        }
        return defs;
    };

    const Grid2Canvas = (): JQuery.Promise<any>[] => {
        const defs = [];
        if (widgetType === 'pdc-widget-layout') {
            const grids = popupDocument.getElementsByClassName('pdc-widget-grid');
            const origGrid = _.clone(container.getElementsByClassName('pdc-widget-grid'));

            _.each(grids, (grid, i) => {
                const virtuarow = $(grid).find('.dx-virtual-row');

                virtuarow.remove();

                const gridImg = new Image();

                gridImg.width = $(origGrid[0]).width();
                // gridImg.height = $(origGrid).height();
                defs.push(
                    html2Canvas(origGrid[0], gridImg, defs.length).done((index) => {
                        $(grid).replaceWith(gridImg);
                        defs[index].resolve();
                    })
                );
            });
        }
        return defs;
    };

    const Container2Canvas = (): JQuery.Promise<any>[] => {
        const defs = [];

        if (widgetType === 'pdc-widget-layout' /* || widgetType === 'pdc-widget-html'+*/) {
            let containers = $(popupDocument).find('.' + widgetType);
            _.each(containers, (container) => {
                $(container).parent().css('height', '100%');
                const width = $(container).width();
                const height = $(container).height();
                const containerImg = new Image();

                containerImg.width = width;
                containerImg.height = height;
                defs.push(
                    html2Canvas(container, containerImg, defs.length).done((index) => {
                        $(container).replaceWith(containerImg);
                        defs[index].resolve();
                    })
                );
            });
        }
        return defs;
    };

    const html2Canvas = (tmp, Img, index, type = 'image/jpeg', backgroundColor = '#ffffff'): JQuery.Promise<any> => {
        const def = $.Deferred();
        $(tmp).attr('crossOrigin', 'anonymous');
        html2canvas(tmp, {
            backgroundColor: backgroundColor,
            svgRendering: true,
            allowTaint: true,
            useCORS: true,
            logging: TestMode,
            width: $(tmp).width(),
            height: $(tmp).height(),
            onclone: function (doc) {}
        }).then((canvas) => {
            try {
                const imgData = canvas.toDataURL(type);

                Img.src = imgData;
                extraInfoTable.appendChild(Img);
                Img.onload = () => {
                    def.resolve(index);
                };
                Img.onerror = (e) => {
                    def.resolve(index);
                };

                if (Img) {
                    Img.parentNode.removeChild(Img);
                }
            } catch (e) {
                console.log(e.message);
                def.resolve(index);
            }
        });

        return def;
    };

    isDataURL.regex =
        /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;

    function isDataURL(s) {
        return !!s.match(isDataURL.regex);
    }

    //Get svg markup as string
    const myHtml2canvas = (): JQuery.Promise<any>[] => {
        let defs = [];

        try {
            /*popupDocument.querySelectorAll('.bi').forEach(icon => {
                const iconName = icon.classList.toString().match(/bi-(.*?)(\s|$)/)[1];
                icon.outerHTML = `<svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                  <use xlink:href="#${iconName}"></use>
                </svg>`;
            });*/
            let svgs = _.clone(popupDocument.getElementsByTagName('svg'));
            let imgs = _.clone(popupDocument.getElementsByTagName('img'));

            if (actionType == IActionType.exportToPdf) {
                //pageFooter to img
                if (pageFooter) {
                    var footerTmp = popupDocument.createElement('div');
                    footerTmp.innerHTML = pageFooter;
                    let style = getAlignStyle(pageFooter);
                    footerTextAligh = style ? style['text-align'] || style['float'] : '';

                    $(footerTmp).attr('crossOrigin', 'anonymous');
                    extraInfoTable.appendChild(footerTmp);
                    _.map($(footerTmp).find('img'), (el: any) => {
                        let url = el.src;
                        let absUrl = url;
                        if (url) {
                            if (isRelativeURL(url)) {
                                absUrl = absUrl.replace(/^\.\//, config.API_ENDPOINT + '/');
                            }
                            if (window.location.host === 'localhost') {
                                absUrl = absUrl.replace(
                                    window.location.origin + window.location.pathname,
                                    config.API_ENDPOINT + '/'
                                );
                            }
                            $(el).attr('src', absUrl);
                        }
                    });
                    footerImg = new Image();
                    defs.push(
                        html2Canvas(footerTmp, footerImg, defs.length).done((index) => {
                            defs[index].resolve();
                        })
                    );
                }

                //--------------------
                if (coverPageDiv) {
                    //$(coverPageTmp).attr('crossOrigin', 'anonymous');
                    extraInfoTable.appendChild(coverPageDiv);
                    _.map($(coverPageDiv).find('img'), (el: any) => {
                        let url = el.src;
                        let absUrl = url;
                        if (url) {
                            if (isRelativeURL(url)) {
                                absUrl = absUrl.replace(/^\.\//, config.API_ENDPOINT + '/');
                            }
                            if (window.location.host === 'localhost') {
                                absUrl = absUrl.replace(
                                    window.location.origin + window.location.pathname,
                                    config.API_ENDPOINT + '/'
                                );
                                $(el).attr('src', absUrl);
                            }
                        }
                    });
                    coverPageImg = new Image();
                    defs.push(
                        html2Canvas(coverPageDiv, coverPageImg, defs.length).done((index) => {
                            defs[index].resolve();
                        })
                    );
                }

                //--------------
                //pageHeader to img
                if (pageHeader) {
                    var headerTmp = popupDocument.createElement('div');
                    headerTmp.innerHTML = pageHeader;
                    let style = getAlignStyle(pageHeader);
                    headerTextAligh = style ? style['text-align'] || style['float'] : '';

                    $(headerTmp).attr('crossOrigin', 'anonymous');
                    extraInfoTable.appendChild(headerTmp);
                    _.map($(headerTmp).find('img'), (el: any) => {
                        let url = el.src;
                        let absUrl = url;
                        if (url) {
                            if (isRelativeURL(url)) {
                                absUrl = absUrl.replace(/^\.\//, config.API_ENDPOINT + '/');
                            }
                            if (window.location.host === 'localhost') {
                                absUrl = absUrl.replace(
                                    window.location.origin + window.location.pathname,
                                    config.API_ENDPOINT + '/'
                                );
                                $(el).attr('src', absUrl);
                            }
                        }
                    });
                    headerImg = new Image();
                    defs.push(
                        html2Canvas(headerTmp, headerImg, defs.length).done((index) => {
                            defs[index].resolve();
                        })
                    );
                }

                //---------------
                defs = imgToCanvas(defs);

                //----------
                if (svgs && svgs.length > 0) {
                    _.each(svgs, (elem) => {
                        defs.push(
                            svg2Canvas(elem, defs.length).done((index) => {
                                defs[index].resolve();
                            })
                        );
                    });
                }
            }

            if (actionType == IActionType.copyToClipboard) {
                if (imgs && imgs.length > 0) {
                    _.each(imgs, (el) => {
                        var canvas = document.createElement('canvas');
                        let img = popupDocument.createElement('img');
                        var tempImg = new Image();
                        tempImg.crossOrigin = 'anonymous';
                        var def = $.Deferred();
                        defs.push(def);
                        var origImg = $(el);
                        var width = origImg.width();
                        var height = origImg.height();
                        canvas.width = width;
                        canvas.height = height;
                        tempImg.src = el.src;
                        tempImg.onload = (e) => {
                            var self: any = e.target;
                            var context = canvas.getContext('2d');
                            //prepareTransparency(canvas, context);
                            context.drawImage(self, 0, 0, width, height);
                            img.width = width;
                            img.height = height;
                            var imgData = canvas.toDataURL('image/jpeg', 0.8);
                            img.src = imgData;
                            origImg.replaceWith(img);
                            def.resolve();
                        };

                        tempImg.onerror = (e) => {
                            def.resolve();
                        };
                    });
                } else {
                    return defs;
                }
                return defs;
            }
        } catch (error) {
            console.error(error.message);
            if (pdfOptions.onReady && typeof pdfOptions.onReady === 'function') {
                pdfOptions.onReady();
            }
            if (!TestMode) {
                popup.close();
            }
        }
        return defs;
    };

    if (actionType == IActionType.exportToPdf || actionType == IActionType.copyToClipboard) {
        popup.onload = () => {
            var jsPDFOptions: any = {
                orientation: pdfOptions.layout,
                unit: 'px',
                format: pdfOptions.papersize,
                compress: true,
                hotfixes: ['px_scaling'],
                putOnlyUsedFonts: true
            };
            const doc = new jsPDF(jsPDFOptions);

            const defs1 = Container2Canvas();
            const defs2 = Progressbar2Canvas();
            $.when(..._.union(defs1, defs2)).always(() => {
                const defs3 = GIS2Canvas();
                // const defs4 = Grid2Canvas();
                $.when(..._.union(defs3 /*, defs4*/)).always(() => {
                    const defs = myHtml2canvas();

                    if (actionType == IActionType.copyToClipboard) {
                        $.when(...defs).always(() => {
                            const body = $(popupDocument.body);
                            const printContent = body.find('.printContent');

                            if (printContent && printContent.length > 0) {
                                printContent[0].className = 'pdc-print-pdf pdc-platform';
                            } else {
                                if (pdfOptions.onReady && typeof pdfOptions.onReady === 'function') {
                                    pdfOptions.onReady();
                                }
                                if (!TestMode) {
                                    popup.close();
                                }
                                return;
                            }

                            const html_blob = new Blob([printContent[0].innerHTML], { type: 'text/html' });

                            popup.focus();
                            pdfOptions.onReady(html_blob);

                            if (!TestMode) {
                                popup.close();
                            }
                        });
                    }

                    if (actionType == IActionType.exportToPdf) {
                        $.when(...defs).always(() => {
                            let scale = 0.3;

                            if (headerImg?.height > loadingIndicatorHeigth) {
                                $(parentTable).css('top', headerImg.height + 'px');
                            }

                            const body = $(popupDocument.body);
                            const printContent = body.find('.printContent');
                            //const paperSize = getPageDimensions(pdfOptions.papersize, pdfOptions.layout);

                            if (printContent && printContent.length > 0) {
                                printContent[0].className = 'pdc-print-pdf pdc-platform';
                            } else {
                                if (pdfOptions.onReady && typeof pdfOptions.onReady === 'function') {
                                    pdfOptions.onReady();
                                }

                                if (!TestMode) {
                                    popup.close();
                                }

                                return;
                            }

                            let top = MARGIN;
                            let bottom = MARGIN;

                            const right = MARGIN;
                            const left = MARGIN;
                            const titleInlineSize = 20;
                            const inlineSize = 10;
                            const inlineSizeClock = 15;
                            const elementWidth = $(printContent).get(0).scrollWidth;
                            const pageWidth = doc.internal.pageSize.getWidth() - left - right;

                            scale = pageWidth / elementWidth;

                            if (pdfOptions?.showTitle) {
                                top = top + titleInlineSize;
                            }

                            if (pdfOptions?.showClock) {
                                top = top + inlineSizeClock;
                            }

                            if (headerImg?.height && isImgExist(doc, headerImg)) {
                                const HeaderImageData = doc.getImageProperties(headerImg);
                                let elementWidth = HeaderImageData.width;
                                let scale = 0.3;
                                if (elementWidth * scale > pageWidth) {
                                    scale = pageWidth / elementWidth;
                                }
                                top = top + HeaderImageData.height * scale;
                            }

                            if (footerImg?.height && isImgExist(doc, footerImg)) {
                                const FooterImageData = doc.getImageProperties(footerImg);
                                let elementWidth = FooterImageData.width;
                                let scale = 0.3;
                                if (elementWidth * scale > pageWidth) {
                                    scale = pageWidth / elementWidth;
                                }
                                bottom = bottom + FooterImageData.height * scale + inlineSize;
                            }

                            let pageCount: number;
                            let isCoverPage: boolean;

                            try {
                                doc.setFontSize(15);
                                const cellPadding = 4;
                                const pdfcallback = (doc) => {
                                    addFonts(doc, actionType);

                                    if (tableProps != null) {
                                        // Определяем размер страницы и положение таблицы
                                        const pageWidth = doc.internal.pageSize.getWidth();
                                        const workspace = doc.internal.pageSize.getWidth() - left - right;
                                        var startX = tableProps.offset.left * (72 / 96);
                                        var startY = (tableProps.offset.top - 150) * (72 / 96) + top;
                                        var height = tableProps.offset.height * (72 / 96);

                                        var width = tableProps.offset.width * (72 / 96) - left - right;
                                        if (width > workspace) {
                                            width = workspace;
                                        }

                                        scale = pageWidth / $(printContent).width();
                                        let margin = { left: left + startX, top: top, right: right, bottom: bottom };
                                        tableToPDF(doc, tableProps, width, margin, cellPadding, scale);
                                        // doc.rect(left, startY, pageWidth, doc.lastAutoTable.finalY);
                                    }

                                    const defs = addExtraInfo(
                                        name,
                                        pdfOptions,
                                        coverPageImg,
                                        doc,
                                        headerImg,
                                        headerTextAligh,
                                        right,
                                        left,
                                        titleInlineSize,
                                        inlineSizeClock,
                                        inlineSize,
                                        footerImg,
                                        footerTextAligh,
                                        MARGIN
                                    );

                                    if (coverPageImg?.src && isImgExist(doc, coverPageImg)) {
                                        const coverPageImageData = doc.getImageProperties(coverPageImg);

                                        doc.insertPage(1);

                                        let pageHeight = doc.internal.pageSize.height - MARGIN * 2;

                                        if (pdfOptions?.showPages) {
                                            pageHeight = pageHeight - 10;
                                        }

                                        let coverpageWidth = coverPageImageData.width * scale;
                                        let coverpageHeight = coverPageImageData.height * scale;

                                        if (coverpageWidth > pageWidth) {
                                            coverpageHeight = (pageWidth * coverpageHeight) / coverpageWidth;
                                            coverpageWidth = pageWidth;
                                        }

                                        doc.addImage(
                                            coverPageImg,
                                            'PNG',
                                            pageWidth / 2 - coverpageWidth / 2,
                                            MARGIN,
                                            coverpageWidth,
                                            coverpageHeight
                                        );

                                        let pages = 'Page ' + String(1) + ' of ' + String(pageCount + 1);
                                        if (pdfOptions?.showPages) {
                                            doc.text(pages, pageWidth / 2, doc.internal.pageSize.height - 10, {
                                                align: 'center'
                                            });
                                        }
                                    }

                                    if (pdfOptions.outputFormat === 'blob') {
                                        const pdf_blob = new Blob([doc.output('blob')], {
                                            type: 'application/pdf'
                                        });

                                        pdfOptions.onReady(pdf_blob);

                                        if (!TestMode) {
                                            popup.close();
                                        }
                                    } else {
                                        pdfOptions.onReady(doc.output());

                                        if (!TestMode) {
                                            popup.close();
                                        }
                                    }
                                    $.when(...defs).always(() => {
                                        if (pdfOptions.outputFormat === 'blob') {
                                            const pdf_blob = new Blob([doc.output('blob')], {
                                                type: 'application/pdf'
                                            });

                                            pdfOptions.onReady(pdf_blob);

                                            if (!TestMode) {
                                                popup.close();
                                            }
                                        } else {
                                            pdfOptions.onReady(doc.output());

                                            if (!TestMode) {
                                                popup.close();
                                            }
                                        }
                                    });
                                };
                                let tableProps: IHTMLTablePropertiesForPrinting;
                                if (pdfOptions.makeHTMLTableForPrinting != null) {
                                    tableProps = pdfOptions.makeHTMLTableForPrinting(popupDocument, { scale: scale });
                                }
                                new jsPDF(jsPDFOptions).html(printContent[0], {
                                    margin: [top, right, bottom, left],
                                    autoPaging: 'text',
                                    html2canvas: {
                                        //ignoreElements(el) {
                                        // return el.classList.contains('dx-datagrid')
                                        // return typeof el.shadowRoot === 'object' && el.shadowRoot !== null;
                                        //},
                                        scale: scale,
                                        useCORS: true,
                                        svgRendering: true,
                                        logging: TestMode,
                                        allowTaint: true
                                    },
                                    callback: (res: any) => {
                                        if (
                                            res.internal.getNumberOfPages() <= 1 ||
                                            pdfOptions.makeHTMLTableForPrinting != null
                                        ) {
                                            pdfcallback(res);
                                        } else {
                                            //90254: Acrobat complains about an Error in generated PDF for Risk List
                                            // add pages that are required by the rendered HTML (start with page 2)
                                            for (let i = 2, j = res.internal.getNumberOfPages(); i <= j; i++) {
                                                doc.addPage(pdfOptions.papersize, pdfOptions.layout);
                                            }
                                            doc.html(printContent[0], {
                                                margin: [top, right, bottom, left],
                                                autoPaging: 'text',
                                                html2canvas: {
                                                    //ignoreElements(el) {
                                                    // return typeof el.shadowRoot === 'object' && el.shadowRoot !== null;
                                                    // },
                                                    scale: scale,
                                                    useCORS: true,
                                                    svgRendering: true,
                                                    logging: TestMode, //Enable logging for debug purposes
                                                    allowTaint: true //Whether to allow cross-origin images to taint the canvas
                                                },

                                                callback: function (doc) {
                                                    pdfcallback(doc);
                                                }
                                            });
                                        }
                                    }
                                });
                            } catch (error) {
                                if (pdfOptions.onReady && typeof pdfOptions.onReady === 'function') {
                                    pdfOptions.onReady();
                                }
                                console.error(error.message);
                            }
                        });
                    }
                });
            });
        };
    } else {
        const doPrint = () => {
            const defs1 = GIS2Canvas();

            if (defs1.length === 0) {
                popup.width = popup.width + 10;
                popup.focus();
                (popup as any).print();
            } else {
                $.when(...defs1).always(() => {
                    popup.width = popup.width + 10;
                    popup.focus();
                    (popup as any).print();

                    if (isFF) {
                        if (pdfOptions.onReady && typeof pdfOptions.onReady === 'function') {
                            pdfOptions.onReady();
                        }

                        if (!TestMode) {
                            popup.close();
                        }
                    }
                });
            }
        };

        const onImgToCanvasCallback = () => {
            if (isIE) {
                popup.onload = new (function () {
                    const defs1 = GIS2Canvas();
                    $.when(...defs1).always(() => {
                        popup.focus();
                        (popup as any).print();
                        if (pdfOptions.onReady && typeof pdfOptions.onReady === 'function') {
                            pdfOptions.onReady();
                        }
                        if (!TestMode) {
                            popup.close();
                        }
                    });
                })();
            } else {
                popup.onafterprint = function () {
                    if (pdfOptions.onReady && typeof pdfOptions.onReady === 'function') {
                        pdfOptions.onReady();
                    }
                    if (!TestMode) {
                        popup.close();
                    }
                    //In firefox not work when dom.allow_scripts_to_close_windows" = "false"
                };

                popup.addEventListener('load', function () {
                    doPrint();
                });
            }
        };

        var defs = [];
        defs = imgToCanvas(defs);
        if (defs.length === 0) {
            onImgToCanvasCallback();
        } else {
            $.when(...defs).always(() => {});
            onImgToCanvasCallback();
        }
    }
}

export const getPageDimensions = (size: string, orientation: string): { width: number; height: number } => {
    const sz = standardSizes[size];

    if (sz) {
        const W = sz.width * TO_PIXELS * TO_PDF_DPI;
        const H = sz.height * TO_PIXELS * TO_PDF_DPI;

        if (orientation === 'portrait' || orientation === 'p') {
            return {
                width: W,
                height: H
            };
        } else {
            return {
                width: H,
                height: W
            };
        }
    } else {
        return {
            width: 200 * TO_PIXELS * TO_PDF_DPI,
            height: 287 * TO_PIXELS * TO_PDF_DPI
        };
    }
};

